var AdolopedEtdActions, AdolopmentDataActions, CERTAINTY_OF_EVIDENCE_CIRCLES, CERTAINTY_OF_EVIDENCE_CRITERIA, CERTAINTY_OF_EVIDENCE_TOTAL_CIRCLES, EtdActions, EtdVotingStore, HtmlExport, QUESTION_VIEW_NAME_TO_PRINTOUT_TYPE, RECOMMENDATION_STRENGTHS_FROM_SELECTOR, W, alt, convertFromRaw, convertMaybeDraftJsToPlainText, draftRenderer, etdHelper, etdTemplatesSections, exportAgreeScore, exportAndSplitBySemicolon, exportAssessmentSummary, exportBooleanWithAdditionalOptions, exportCodeField, exportConclusions, exportFieldWithMissing, exportGuidelineFields, exportIsof, exportJustification, exportJustificationPromise, exportJustificationText, exportYesNoTextField, get, getAssessmentSectionsPromises, getCertaintyOfEvidenceAndLabel, getCertaintyOfEvidenceCircles, getConclusionsContentPromise, getContentPromise, getEtdPrintout, getHtmlContentFromEpiditorRender, getPromiseOrResolveString, getQuestionIsofData, getRecommendationDirectionAndStrength, getRecommendationMetadata, getRecommendationMetadataOrUndefined, getRecommendationText, getRecommendationTextContent, getReferencesFromEpiditorRender, getRemarks, getRemarksContent, getRemarksText, getSofPrintout, gradeProCodeToWHOCode, mediator, renderEditorValue, renderEditorValueFromRecommendationMetadata, sanitizeHTML,
  __indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

AdolopedEtdActions = require('actions/adoloped_etd_actions');

AdolopmentDataActions = require('actions/adolopment_data_actions');

alt = require('alt');

draftRenderer = require('lib/services/jsonld_exporter/draft_renderer');

EtdActions = require('actions/etd_actions');

etdHelper = require('lib/etd_helper');

etdTemplatesSections = require('lib/etd_templates/templates_sections');

EtdVotingStore = require('stores/etd_voting_store');

get = require('lodash').get;

getQuestionIsofData = require('lib/questions_helper').getQuestionIsofData;

HtmlExport = require('lib/html_export');

mediator = require('mediator');

QUESTION_VIEW_NAME_TO_PRINTOUT_TYPE = require('lib/questions_helper').QUESTION_VIEW_NAME_TO_PRINTOUT_TYPE;

sanitizeHTML = require('base/lib/utils').sanitizeHTML;

getContentPromise = require('lib/services/document_sections_exporter/utils').getContentPromise;

W = require('when/when');

convertFromRaw = Draft.convertFromRaw;

CERTAINTY_OF_EVIDENCE_TOTAL_CIRCLES = 4;

CERTAINTY_OF_EVIDENCE_CIRCLES = {
  'very_low': 1,
  'low': 2,
  'moderate': 3,
  'high': 4
};

gradeProCodeToWHOCode = function(_arg) {
  var codeType, name, value;
  codeType = _arg.codeType, value = _arg.value, name = _arg.name;
  return {
    'code': {
      '@type': codeType,
      'value': sanitizeHTML(value)
    },
    'name': sanitizeHTML(name)
  };
};

exportGuidelineFields = function(exportFunction, fields, fieldsMap, guidelineDoc) {
  return _.chain(fields).map(function(field) {
    return [field, exportFunction(guidelineDoc[field])];
  }).map(function(_arg) {
    var key, value;
    key = _arg[0], value = _arg[1];
    if (key in fieldsMap) {
      return [fieldsMap[key], value];
    } else {
      return [key, value];
    }
  }).object().value();
};

renderEditorValue = function(value) {
  if (!Boolean(value)) {
    return '';
  }
  return draftRenderer.renderDraftJsContentToHTML(value);
};

exportJustificationText = function(recommendation) {
  var details, detailsDescription, justification, overallContent, overallDescription, sectionsOrder, _ref;
  justification = get(recommendation, 'templateData.conclusions.sections.justification');
  if (!justification) {
    return void 0;
  }
  overallContent = renderEditorValue(get(justification, 'content'));
  if (!overallContent) {
    return void 0;
  }
  sectionsOrder = (_ref = get(recommendation, 'templateData.assessment.sectionsOrder')) != null ? _ref : [];
  details = _.reduce(sectionsOrder, function(acc, key) {
    var name, value;
    name = get(recommendation, "templateData.assessment.sections." + key + ".name");
    value = get(justification, "details.criteria." + key);
    if (!value) {
      return acc;
    }
    return "" + acc + "<br /><br /><span style='font-style: italic'>" + name + "</span><br />" + value;
  }, '');
  if (!details) {
    return overallContent;
  }
  overallDescription = get(etdTemplatesSections(), 'conclusions.sections.justification.overallDescription');
  detailsDescription = get(etdTemplatesSections(), 'conclusions.sections.justification.details.description');
  return "<div> <span style='font-weight: bold'>" + overallDescription + "</span><br /> " + overallContent + " <br /><br /> <span style='font-weight: bold'>" + detailsDescription + "</span><br /> " + details + " </div>";
};

exportJustification = function(recommendation) {
  var justificationText;
  justificationText = exportJustificationText(recommendation);
  if (!justificationText) {
    return void 0;
  }
  return {
    content: justificationText
  };
};

exportConclusions = function(recommendation, sectionsToOmit) {
  var sections, sectionsOrder, sectionsToReturn, _ref;
  sectionsOrder = (_ref = get(recommendation, 'templateData.conclusions.sectionsOrder')) != null ? _ref : [];
  sectionsOrder = _.reject(sectionsOrder, function(s) {
    return __indexOf.call(sectionsToOmit, s) >= 0 || __indexOf.call(etdHelper.getRecommendationTypeSections(), s) >= 0;
  });
  sectionsToReturn = _.reject(sectionsOrder, function(s) {
    return s === 'justification';
  });
  sections = _.chain(sectionsToReturn).map(function(sectionId) {
    var content, section, selectedOption;
    section = get(recommendation, "templateData.conclusions.sections." + sectionId);
    content = renderEditorValue(get(section, 'content'));
    if (!content) {
      content = void 0;
    }
    selectedOption = get(section, 'selectedOption');
    if (!selectedOption) {
      selectedOption = void 0;
    }
    if (!(content || selectedOption)) {
      return null;
    }
    return [
      sectionId, {
        content: content,
        selectedOption: selectedOption
      }
    ];
  }).compact().object().value();
  return {
    sectionsOrder: sectionsOrder,
    sections: sections
  };
};

getConclusionsContentPromise = function(recommendation, sectionsToOmit) {
  var sectionsOrder, sectionsToReturn, _ref;
  sectionsOrder = (_ref = get(recommendation, 'templateData.conclusions.sectionsOrder')) != null ? _ref : [];
  sectionsOrder = _.reject(sectionsOrder, function(s) {
    return __indexOf.call(sectionsToOmit, s) >= 0 || __indexOf.call(etdHelper.getRecommendationTypeSections(), s) >= 0;
  });
  sectionsToReturn = _.reject(sectionsOrder, function(s) {
    return s === 'justification';
  });
  return W.all(W.reduce(sectionsToReturn, function(acc, sectionId) {
    var content, contentPromise, promise, section, selectedOption;
    section = get(recommendation, "templateData.conclusions.sections." + sectionId);
    content = get(section, 'content');
    selectedOption = get(section, 'selectedOption');
    contentPromise = getPromiseOrResolveString(content, sectionId);
    promise = contentPromise.then(function(content) {
      return {
        key: sectionId,
        content: getHtmlContentFromEpiditorRender(content),
        referenceData: getReferencesFromEpiditorRender(content),
        selectedOption: selectedOption
      };
    });
    acc.push(promise);
    return acc;
  }, [])).then(function(sections) {
    return {
      sectionsOrder: sectionsOrder,
      sections: _.chain(sections).map(function(_arg) {
        var content, key, referenceData, selectedOption;
        key = _arg.key, content = _arg.content, selectedOption = _arg.selectedOption, referenceData = _arg.referenceData;
        if (!(content || selectedOption)) {
          return null;
        }
        return [
          key, {
            content: content,
            selectedOption: selectedOption,
            referenceData: referenceData
          }
        ];
      }).compact().object().value()
    };
  });
};

exportAssessmentSummary = function(recommendation) {
  var sections, sectionsOrder, _ref;
  sectionsOrder = (_ref = get(recommendation, 'templateData.assessment.sectionsOrder')) != null ? _ref : [];
  sections = _.chain(sectionsOrder).map(function(key) {
    var acId, additionalConsiderations, criterionId, reId, researchEvidences, value;
    criterionId = get(recommendation, "templateData.assessment.sections." + key + ".criterionId");
    reId = get(recommendation, "templateData.assessment.sections." + key + ".researchEvidenceId");
    acId = get(recommendation, "templateData.assessment.sections." + key + ".additionalConsiderationId");
    if (!criterionId) {
      return null;
    }
    value = get(recommendation, "templateData.assessment.criteria." + criterionId + ".selectedOption");
    researchEvidences = get(recommendation, "templateData.assessment.researchEvidences." + reId + ".content", '');
    additionalConsiderations = get(recommendation, "templateData.assessment.additionalConsiderations." + acId + ".content", '');
    if (((value == null) || value === '') && ((researchEvidences == null) || researchEvidences === '') && ((additionalConsiderations == null) || additionalConsiderations === '')) {
      return null;
    }
    return [
      key, {
        value: value,
        researchEvidences: researchEvidences,
        additionalConsiderations: additionalConsiderations
      }
    ];
  }).compact().object().value();
  if (!sections) {
    return void 0;
  }
  return {
    sections: sections,
    sectionsOrder: sectionsOrder
  };
};

getAssessmentSectionsPromises = function(recommendation) {
  var sectionsOrder, _ref;
  sectionsOrder = (_ref = get(recommendation, 'templateData.assessment.sectionsOrder')) != null ? _ref : [];
  return W.all(W.reduce(sectionsOrder, function(acc, key) {
    var acId, acPromise, additionalConsiderations, criterionId, reId, rePromise, researchEvidences, sectionPromise, value;
    criterionId = get(recommendation, "templateData.assessment.sections." + key + ".criterionId");
    reId = get(recommendation, "templateData.assessment.sections." + key + ".researchEvidenceId");
    acId = get(recommendation, "templateData.assessment.sections." + key + ".additionalConsiderationId");
    if (!criterionId) {
      return acc;
    }
    value = get(recommendation, "templateData.assessment.criteria." + criterionId + ".selectedOption");
    researchEvidences = get(recommendation, "templateData.assessment.researchEvidences." + reId + ".content", '');
    additionalConsiderations = get(recommendation, "templateData.assessment.additionalConsiderations." + acId + ".content", '');
    rePromise = getPromiseOrResolveString(researchEvidences, reId);
    acPromise = getPromiseOrResolveString(additionalConsiderations, acId);
    sectionPromise = W.all([rePromise, acPromise]).then(function(_arg) {
      var acContent, reContent;
      reContent = _arg[0], acContent = _arg[1];
      return {
        key: key,
        value: value,
        researchEvidences: reContent,
        additionalConsiderations: acContent
      };
    });
    acc.push(sectionPromise);
    return acc;
  }, [])).then(function(sections) {
    return {
      sectionsOrder: sectionsOrder,
      sections: _.chain(sections).map(function(_arg) {
        var acReferences, additionalConsiderations, key, reReferences, researchEvidences, value;
        key = _arg.key, value = _arg.value, researchEvidences = _arg.researchEvidences, additionalConsiderations = _arg.additionalConsiderations;
        if (!(value || researchEvidences || additionalConsiderations)) {
          return null;
        }
        reReferences = getReferencesFromEpiditorRender(researchEvidences);
        acReferences = getReferencesFromEpiditorRender(additionalConsiderations);
        return [
          key, {
            value: value,
            researchEvidences: getHtmlContentFromEpiditorRender(researchEvidences || '', {
              additionalConsiderations: getHtmlContentFromEpiditorRender(additionalConsiderations || ''),
              referenceData: {
                references: reReferences.references.concat(acReferences.references),
                referencesFromTables: reReferences.referencesFromTables.concat(acReferences.referencesFromTables),
                fullReferencesData: reReferences.fullReferencesData.concat(acReferences.fullReferencesData)
              }
            })
          }
        ];
      }).compact().object().value()
    };
  });
};

exportJustificationPromise = function(recommendation) {
  var content, contentPromise, justification, sectionsOrder, _ref;
  justification = get(recommendation, 'templateData.conclusions.sections.justification');
  if (!justification) {
    return W.resolve();
  }
  content = get(justification, 'content');
  contentPromise = getPromiseOrResolveString(content, 'justification');
  sectionsOrder = (_ref = get(recommendation, 'templateData.assessment.sectionsOrder')) != null ? _ref : [];
  return contentPromise.then(function(overallContent) {
    var details, detailsDescription, overallDescription, referenceData;
    if (!overallContent) {
      return void 0;
    }
    referenceData = getReferencesFromEpiditorRender(overallContent);
    overallContent = getHtmlContentFromEpiditorRender(overallContent);
    details = _.reduce(sectionsOrder, function(acc, key) {
      var name, value;
      name = get(recommendation, "templateData.assessment.sections." + key + ".name");
      value = get(justification, "details.criteria." + key);
      if (!value) {
        return acc;
      }
      return "" + acc + "<br /><span style='font-style: italic'>" + name + "</span><br />" + value;
    }, '');
    if (!details) {
      return {
        content: overallContent,
        referenceData: referenceData
      };
    }
    overallDescription = get(etdTemplatesSections(), 'conclusions.sections.justification.overallDescription');
    detailsDescription = get(etdTemplatesSections(), 'conclusions.sections.justification.details.description');
    return {
      content: "<div> <span style='font-weight: bold'>" + overallDescription + "</span><br /> " + overallContent + " <br /> <span style='font-weight: bold'>" + detailsDescription + "</span><br /> " + details + " </div>",
      referenceData: referenceData
    };
  });
};

getPromiseOrResolveString = function(content, id) {
  if (_.isString(content)) {
    return W.resolve(content);
  } else {
    return getContentPromise(id, Immutable.fromJS(content));
  }
};

exportFieldWithMissing = function(value) {
  if (value == null) {
    return void 0;
  }
  if (value === 'missing') {
    return void 0;
  }
  return value;
};

RECOMMENDATION_STRENGTHS_FROM_SELECTOR = {
  'recommend_against': ['negative', 'strong'],
  'suggest_against': ['negative', 'weak'],
  'suggest_either': ['none', 'weak'],
  'suggest': ['positive', 'weak'],
  'recommend': ['positive', 'strong']
};

getRecommendationMetadata = function(recommendation, key, defaultValue) {
  var _ref;
  if (defaultValue == null) {
    defaultValue = [];
  }
  return [].concat((_ref = get(recommendation, "templateData.conclusions.sections.recommendation." + key)) != null ? _ref : defaultValue);
};

getRecommendationMetadataOrUndefined = function(recommendation, key) {
  var value;
  value = getRecommendationMetadata(recommendation, key);
  if (_.isEmpty(value)) {
    return void 0;
  }
  value = value[0];
  if (value == null) {
    return void 0;
  }
  return value;
};

renderEditorValueFromRecommendationMetadata = function(recommendation, key) {
  var value;
  value = getRecommendationMetadataOrUndefined(recommendation, key);
  if (!value) {
    return void 0;
  }
  return renderEditorValue(value);
};

getRecommendationDirectionAndStrength = function(recommendation) {
  var additionalRecommendationOptions, conclusionsInTemplate, recommendationDirection, recommendationOption, recommendationOptionValue, recommendationOptions, recommendationStrength, recommendationTypeDef, recommendationTypeId, _ref;
  recommendationStrength = exportFieldWithMissing(getRecommendationMetadata(recommendation, 'strengthOfRecommendation')[0]);
  if (recommendationStrength != null) {
    if (recommendationStrength in RECOMMENDATION_STRENGTHS_FROM_SELECTOR) {
      return RECOMMENDATION_STRENGTHS_FROM_SELECTOR[recommendationStrength];
    }
    return ['none', recommendationStrength];
  }
  conclusionsInTemplate = (_ref = recommendation != null ? recommendation['templateDef']['conclusions'] : void 0) != null ? _ref : [];
  recommendationTypeDef = _.find(conclusionsInTemplate, function(_arg) {
    var checked, id, required;
    id = _arg.id, checked = _arg.checked, required = _arg.required;
    return (Boolean(checked) || Boolean(required)) && __indexOf.call(etdHelper.getRecommendationTypeSections(), id) >= 0;
  });
  if (!recommendationTypeDef) {
    return [void 0, void 0, void 0];
  }
  recommendationTypeId = recommendationTypeDef.id;
  recommendationOptionValue = get(recommendation, "templateData.conclusions.sections." + recommendationTypeId + ".selectedOption");
  recommendationOptions = get(recommendation, "templateData.conclusions.sections." + recommendationTypeId + ".options");
  additionalRecommendationOptions = get(recommendation, "templateData.conclusions.sections." + recommendationTypeId + ".customOptions");
  recommendationOption = _.find(recommendationOptions.concat(additionalRecommendationOptions || []), function(_arg) {
    var value;
    value = _arg.value;
    return value === recommendationOptionValue;
  });
  if (!recommendationOption) {
    return [void 0, void 0, void 0];
  }
  recommendationDirection = get(recommendationOption, 'direction');
  recommendationStrength = recommendationOptionValue.indexOf('recommend') >= 0 ? 'strong' : 'weak';
  return [recommendationDirection, recommendationStrength, recommendationOption];
};

CERTAINTY_OF_EVIDENCE_CRITERIA = ['certaintyOfEvidence', 'certaintyOfEvidenceOfTestAccuracy'];

getCertaintyOfEvidenceAndLabel = function(recommendation) {
  var certaintyOfEvidence, gradeCertaintyOfEvidenceLabel;
  certaintyOfEvidence = exportFieldWithMissing(getRecommendationMetadata(recommendation, 'certaintyOfEvidence')[0]);
  if (certaintyOfEvidence != null) {
    return [certaintyOfEvidence, 'certainty_of_evidence'];
  }
  certaintyOfEvidence = _.chain(CERTAINTY_OF_EVIDENCE_CRITERIA).map(function(criterion) {
    return get(recommendation, "templateData.assessment.criteria." + criterion + ".selectedOption");
  }).find(function(val) {
    return Boolean(val);
  }).value();
  gradeCertaintyOfEvidenceLabel = certaintyOfEvidence != null ? 'certainty_of_evidence' : void 0;
  return [certaintyOfEvidence, gradeCertaintyOfEvidenceLabel];
};

getEtdPrintout = function(projectId, questionModel, recommendationId) {
  return W.promise(function(resolve, reject) {
    var actions, actionsToStoresMap, callbackId, exportAfterDataIsFetched, hasAdolopment, isFetchingInStores, recommendationAdolopmentIds;
    exportAfterDataIsFetched = function() {
      var htmlExport, options;
      options = EtdVotingStore.getVotingData().isEmpty() ? {} : {
        etdViewMode: 'judgements-consensus#recommendation-consensus#conclusions-proposed',
        showVotingResults: false
      };
      htmlExport = new HtmlExport(questionModel, 'recommendations-v2', options);
      return htmlExport.getSource()["finally"](function() {
        return alt.recycle('EtdStore', 'AdolopedEtdStore', 'QuestionsStore', 'EtdVotingStore', 'ReferencesStore', 'OverarchingQuestionsStore', 'PanelVoiceStore', 'PanelVoiceEtdStore');
      }).then(resolve, reject);
    };
    recommendationAdolopmentIds = questionModel.get('recommendationAdolopmentIds');
    hasAdolopment = !_.isEmpty(recommendationAdolopmentIds);
    isFetchingInStores = {
      etd: true,
      questions: true,
      voting: true,
      references: true,
      adolopmentData: hasAdolopment,
      adolopmentEtd: hasAdolopment
    };
    actionsToStoresMap = {
      'EtdActions.fetchSuccess': 'etd',
      'EtdActions.fetchError': 'etd',
      'ReferencesActions.fetchSuccess': 'references',
      'ReferencesActions.fetchError': 'references',
      'EtdVotingActions.fetchSuccess': 'voting',
      'EtdVotingActions.fetchError': 'voting',
      'QuestionsActions.fetchSuccess': 'questions',
      'QuestionsActions.fetchError': 'questions',
      'AdolopedEtdActions.fetchSuccess': 'adolopmentEtd',
      'AdolopedEtdActions.fetchError': 'adolopmentEtd',
      'AdolopmentDataActions.fetchAdolopmentDataSuccess': 'adolopmentData',
      'AdolopmentDataActions.fetchAdolopmentDataError': 'adolopmentData'
    };
    actions = _(actionsToStoresMap).keys();
    callbackId = alt.dispatcher.register(function(payload) {
      var _ref;
      if (_ref = payload.action, __indexOf.call(actions, _ref) < 0) {
        return;
      }
      isFetchingInStores[actionsToStoresMap[payload.action]] = false;
      if (_.any(_(isFetchingInStores).values())) {
        return;
      }
      alt.dispatcher.unregister(callbackId);
      return setTimeout(exportAfterDataIsFetched, 100);
    });
    EtdActions.fetch({
      dbId: projectId,
      docId: [recommendationId]
    });
    if (hasAdolopment) {
      AdolopedEtdActions.fetch({
        dbId: projectId,
        docIds: recommendationAdolopmentIds
      });
      return AdolopmentDataActions.fetchAdolopmentData(projectId);
    }
  });
};

getSofPrintout = function(questionModel) {
  var hasIDSAFeaturesSwitch, htmlExport, printoutType, viewName;
  hasIDSAFeaturesSwitch = mediator.services.switches.isOn('idsaFeatures');
  viewName = questionModel.isDiagnostic() ? hasIDSAFeaturesSwitch ? 'LayerTwoSof' : 'LayerOneSof' : hasIDSAFeaturesSwitch ? 'SOF_v4' : 'SOF';
  printoutType = QUESTION_VIEW_NAME_TO_PRINTOUT_TYPE[viewName];
  htmlExport = new HtmlExport(questionModel, printoutType, {});
  return htmlExport.getSource('landscape', {}, viewName);
};

exportIsof = function(questionModel, projectName) {
  return getQuestionIsofData(questionModel, projectName);
};

getRecommendationTextContent = function(recommendation, isGps) {
  var sectionId;
  if (isGps == null) {
    isGps = false;
  }
  sectionId = isGps ? 'goodPracticeStatement' : _.some(get(recommendation, 'templateDef.conclusions'), function(_arg) {
    var id;
    id = _arg.id;
    return id === 'decision';
  }) ? 'decision' : 'recommendation';
  return get(recommendation, ("templateData.conclusions.sections." + sectionId + ".content") || '');
};

getRecommendationText = function(recommendation, isGps) {
  if (isGps == null) {
    isGps = false;
  }
  return renderEditorValue(getRecommendationContent(recommendation, isGps));
};

getRemarksContent = function(recommendation) {
  var sectionId;
  sectionId = _.some(get(recommendation, 'templateDef.conclusions'), function(_arg) {
    var id;
    id = _arg.id;
    return id === 'decision';
  }) ? 'decision' : 'recommendation';
  return get(recommendation, "templateData.conclusions.sections." + sectionId + ".remarks.content", '');
};

getRemarks = function(recommendation) {
  return renderEditorValue(getRemarksContent(recommendation));
};

getRemarksText = function(recommendation, isGps) {
  var sectionId;
  if (isGps == null) {
    isGps = false;
  }
  sectionId = isGps ? 'goodPracticeStatement' : _.some(get(recommendation, 'templateDef.conclusions'), function(_arg) {
    var id;
    id = _arg.id;
    return id === 'decision';
  }) ? 'decision' : 'recommendation';
  return renderEditorValue(get(recommendation, "templateData.conclusions.sections." + sectionId + ".remarks.content"));
};

getCertaintyOfEvidenceCircles = function(question, recommendation) {
  var certaintyNumericValue, certaintySelectedOption, circles, criterion, isDiagnostic, label, option, options, sectionName, _ref, _ref1;
  if (!question || !recommendation) {
    return null;
  }
  isDiagnostic = question.get('type') === 'diagnostic';
  sectionName = isDiagnostic ? 'certaintyOfEffects' : 'certaintyOfEvidence';
  criterion = recommendation.getIn(['templateData', 'assessment', 'criteria', sectionName]);
  certaintySelectedOption = criterion != null ? criterion.get('selectedOption') : void 0;
  options = (_ref = criterion != null ? criterion.get('options') : void 0) != null ? _ref : Immutable.List();
  label = certaintySelectedOption != null ? (option = options.find(function(option) {
    return option.get('value') === certaintySelectedOption;
  }), option != null ? option.get('text') : void 0) : null;
  certaintyNumericValue = (_ref1 = CERTAINTY_OF_EVIDENCE_CIRCLES[certaintySelectedOption]) != null ? _ref1 : 0;
  circles = Array(CERTAINTY_OF_EVIDENCE_TOTAL_CIRCLES).fill('').map(function(_elem, idx) {
    if (idx < certaintyNumericValue) {
      return "⨁";
    } else {
      return "◯";
    }
  });
  return {
    label: label,
    circles: circles
  };
};

getHtmlContentFromEpiditorRender = function(content) {
  if (_.isString(content)) {
    return content;
  } else {
    return get(content, 'sections.0.htmlContent');
  }
};

getReferencesFromEpiditorRender = function(content) {
  var _ref, _ref1, _ref2;
  if (_.isString(content)) {
    return {
      references: [],
      referencesFromTables: [],
      fullReferencesData: []
    };
  } else {
    return {
      references: (_ref = get(content, 'references')) != null ? _ref : [],
      referencesFromTables: (_ref1 = get(content, 'referencesFromTables')) != null ? _ref1 : [],
      fullReferencesData: (_ref2 = get(content, 'fullReferencesData')) != null ? _ref2 : []
    };
  }
};

convertMaybeDraftJsToPlainText = function(value) {
  if (value == null) {
    return '';
  }
  if (_.isString(value)) {
    return value;
  }
  return convertFromRaw(value).getPlainText();
};

exportYesNoTextField = function(value) {
  var plainText, showTextInput, text;
  if (value == null) {
    return void 0;
  }
  showTextInput = value.showTextInput, text = value.text;
  plainText = convertMaybeDraftJsToPlainText(text);
  if (plainText === 'notReported') {
    return plainText;
  }
  if (showTextInput) {
    if (_.isString(text)) {
      return text;
    } else {
      return renderEditorValue(text);
    }
  } else {
    return 'no';
  }
};

exportBooleanWithAdditionalOptions = function(value) {
  if (value == null) {
    return void 0;
  }
  return value.toString();
};

exportAgreeScore = function(guidelineDoc) {
  var _ref;
  return {
    'scopeAndPurpose': get(guidelineDoc, 'scopeAndPurpose'),
    'rigorOfDevelopment': get(guidelineDoc, 'rigorOfDevelopment'),
    'editorialProcess': get(guidelineDoc, 'editorialProcess'),
    'scorePassed': (_ref = get(guidelineDoc, 'scorePassed')) != null ? _ref : false
  };
};

exportCodeField = function(fieldValue) {
  if (_.isEmpty(fieldValue)) {
    return [];
  }
  return _.map(fieldValue, function(_arg) {
    var codes, codesRaw, id, value;
    id = _arg.id, value = _arg.value, codesRaw = _arg.codes;
    codes = _.chain(codesRaw).values().map(gradeProCodeToWHOCode).value();
    return {
      '@id': id,
      'name': value,
      'codes': codes
    };
  });
};

exportAndSplitBySemicolon = function(fieldValue) {
  if (_.isEmpty(fieldValue)) {
    return [];
  }
  return _.map(fieldValue.split(';'), function(value) {
    return value.trim();
  });
};

module.exports = {
  convertMaybeDraftJsToPlainText: convertMaybeDraftJsToPlainText,
  exportBooleanWithAdditionalOptions: exportBooleanWithAdditionalOptions,
  exportCodeField: exportCodeField,
  exportYesNoTextField: exportYesNoTextField,
  exportAndSplitBySemicolon: exportAndSplitBySemicolon,
  exportAssessmentSummary: exportAssessmentSummary,
  exportAgreeScore: exportAgreeScore,
  exportConclusions: exportConclusions,
  exportFieldWithMissing: exportFieldWithMissing,
  exportGuidelineFields: exportGuidelineFields,
  exportIsof: exportIsof,
  exportJustification: exportJustification,
  exportJustificationPromise: exportJustificationPromise,
  getAssessmentSectionsPromises: getAssessmentSectionsPromises,
  getCertaintyOfEvidenceAndLabel: getCertaintyOfEvidenceAndLabel,
  getCertaintyOfEvidenceCircles: getCertaintyOfEvidenceCircles,
  getConclusionsContentPromise: getConclusionsContentPromise,
  getEtdPrintout: getEtdPrintout,
  getHtmlContentFromEpiditorRender: getHtmlContentFromEpiditorRender,
  getPromiseOrResolveString: getPromiseOrResolveString,
  getRecommendationDirectionAndStrength: getRecommendationDirectionAndStrength,
  getRecommendationMetadata: getRecommendationMetadata,
  getRecommendationMetadataOrUndefined: getRecommendationMetadataOrUndefined,
  getRecommendationText: getRecommendationText,
  getRecommendationTextContent: getRecommendationTextContent,
  getReferencesFromEpiditorRender: getReferencesFromEpiditorRender,
  getRemarks: getRemarks,
  getRemarksContent: getRemarksContent,
  getRemarksText: getRemarksText,
  getSofPrintout: getSofPrintout,
  gradeProCodeToWHOCode: gradeProCodeToWHOCode,
  renderEditorValue: renderEditorValue,
  renderEditorValueFromRecommendationMetadata: renderEditorValueFromRecommendationMetadata
};
